import { a as parseAuthenticateRequest, c as sendMessages, d as parsePullMessagesRequest, f as parseSendMessagesRequest, i as newMessages, l as PullMessagesRequestSchema, n as AuthenticateResponseSchema, o as parseAuthenticateResponse, r as authenticate, s as pullMessages, t as AuthenticateRequestSchema, u as SendMessagesRequestSchema } from "./v2-BHSVXuXv.mjs";
import * as v from "valibot";
//#region src/memory.ts
const nameSchema = v.pipe(v.string(), v.minLength(1), v.maxLength(64), v.regex(/^[\p{L}\p{N}]+(?:-[\p{L}\p{N}]+)*$/u));
const personaSchema = v.pipe(v.string(), v.minLength(1), v.maxLength(128));
/** One lasting fact. An absent persona makes the fact visible to every character of its owner. */
const memoryEntrySchema = v.strictObject({
	name: nameSchema,
	description: v.pipe(v.string(), v.maxLength(150)),
	body: v.pipe(v.string(), v.minLength(1), v.maxLength(2e3), v.check((body) => body.trim().length > 0)),
	persona: v.optional(personaSchema),
	updatedAt: v.pipe(v.number(), v.integer(), v.minValue(0))
});
/** A field key binds a fact to its scope. Null denotes the owner's general memories. */
const memoryKeySchema = v.pipe(v.string(), v.parseJson(), v.tuple([v.nullable(personaSchema), nameSchema]));
/**
* Encodes scope and name without delimiter ambiguity.
*
* @example
* memoryKey({ name: 'nickname', persona: 'default' })
* // => '["default","nickname"]'
*/
function memoryKey(entry) {
	return JSON.stringify([entry.persona ?? null, entry.name]);
}
//#endregion
export { AuthenticateRequestSchema, AuthenticateResponseSchema, PullMessagesRequestSchema, SendMessagesRequestSchema, authenticate, memoryEntrySchema, memoryKey, memoryKeySchema, newMessages, parseAuthenticateRequest, parseAuthenticateResponse, parsePullMessagesRequest, parseSendMessagesRequest, pullMessages, sendMessages };

//# sourceMappingURL=index.mjs.map